import React, { useCallback } from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import useTilt from "../hooks/useTilt";

const ProjectItem = ({ project, index }) => {
  const [scrollRef, isVisible] = useScrollReveal({ delay: index * 100 });
  const tilt = useTilt(6);
  const mergedRef = useCallback(
    (node) => {
      scrollRef(node);
      tilt.ref.current = node;
    },
    [scrollRef, tilt.ref]
  );

  return (
    <div
      ref={mergedRef}
      className={`columns portfolio-item ${isVisible ? "reveal-visible" : "reveal"}`}
      onMouseMove={tilt.handleMove}
      onMouseLeave={tilt.handleLeave}
    >
      <h3>{project.title}</h3>
      <p>{project.category}</p>
      <div className="item-wrap">
        <div className="card-glare" />
        <div className="card-shine" />
        <a href={project.url} target="_blank" rel="noopener noreferrer">
          <img alt={project.title} src={project.image} />
        </a>
        <div className="tech-stack-bar">
          <span>Tech Stack</span> &mdash; {project.stack}
        </div>
        <div className="project-links">
          <a href={project.url} target="_blank" rel="noopener noreferrer">
            <i className="fa fa-solid fa-rocket"></i> Live Demo
          </a>
          <a href={project.source} target="_blank" rel="noopener noreferrer">
            <i className="fa fa-solid fa-code"></i> Source Code
          </a>
        </div>
      </div>
    </div>
  );
};

const PersonalProjects = ({ data }) => {
  if (!data || !data.projects) return null;

  return (
    <section className="personal-projects-section">
      <div className="moving-line" />
      <div className="moving-line" />
      <div className="row">
        <div className="twelve columns collapsed">
          <h1 className="section-heading">
            <span>Personal Projects</span>
          </h1>
          <div
            id="portfolio-wrapper"
            className="bgrid-quarters s-bgrid-thirds cf"
          >
            {data.projects.map((project, i) => (
              <ProjectItem key={project.title} project={project} index={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PersonalProjects;
